import { Link, useLocation } from 'react-router-dom'
import Icon from './Icon'

const ITEMS = [
  { path: '/dashboard', label: 'Tableau', icon: 'home' },
  { path: '/operations', label: 'Opérations', icon: 'operations' },
  { path: '/graphiques', label: 'Graphiques', icon: 'chart' },
  { path: '/parametres', label: 'Réglages', icon: 'settings' },
]

export default function BottomNav() {
  const location = useLocation()

  const isActive = (path) =>
    location.pathname === path || (path === '/dashboard' && location.pathname === '/')

  return (
    <nav
      className="app-bottom-nav"
      aria-label="Navigation principale"
      style={{ paddingBottom: 'max(0px, env(safe-area-inset-bottom))' }}
    >
      <div className="mx-auto flex max-w-[1200px] items-stretch">
        {ITEMS.map((item) => {
          const active = isActive(item.path)
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`bottom-nav-item ${active ? 'bottom-nav-item-active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              {/* Un trait fin en tête d'onglet marque la page active sans
                  déplacer l'icône ni changer sa taille. */}
              <span
                aria-hidden="true"
                className={`absolute inset-x-5 top-0 h-0.5 rounded-full transition-colors duration-fast ${
                  active ? 'bg-accent' : 'bg-transparent'
                }`}
              />
              <Icon name={item.icon} size={22} strokeWidth={active ? 1.9 : 1.5} />
              <span className="leading-none">{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
